import React, {FC} from "react"
import {Row} from "@irati/ui/src/Layout"

import {Select} from "@irati/ui/src/FormItem"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {CelebrationsReportDuration} from "@irati/types"

interface Props extends InjectIntl {
  onChange: (regionId: string) => void
  value: string
  options: any
}

const TimeRange: FC<Props> = ({value, onChange, formatMessage, options}) => {
  const timeRangeOptions = [
    {
      label: formatMessage({id: "admin.reporting.orgSummary.timeRangeOptions.last30Days"}),
      value: CelebrationsReportDuration.CelebrationsLast_30Days
    },
    {
      label: formatMessage({id: "admin.reporting.orgSummary.timeRangeOptions.last90Days"}),
      value: CelebrationsReportDuration.CelebrationsLast_90Days
    },
    {
      label: formatMessage({id: "admin.reporting.orgSummary.timeRangeOptions.last6Months"}),
      value: CelebrationsReportDuration.CelebrationsLast_6Months
    },
    {
      label: formatMessage({id: "admin.reporting.orgSummary.timeRangeOptions.last12Months"}),
      value: CelebrationsReportDuration.CelebrationsLast_12Months
    }
  ]

  return (
    <Row>
      <Select name="timeRangePollsReporting" options={options || timeRangeOptions} value={value} onChange={onChange} />
    </Row>
  )
}

export default injectIntl(TimeRange)
